// components/ProfileDropdown.jsx
import React, { useState, useRef, useEffect } from 'react';
import '../../styles/Auth/profileDropdown.css';
import ResetPasswordPage from '../../pages/Auth/Reset-Password/reset-password.jsx';
import { useNavigate, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import { getData } from "../../../src/webService/webservice.js";
import { Icon } from "@iconify/react";
const ProfileDropdown = () => {
   
    const [PreviewUrl, setPreviewUrl] = useState("");
    const [showLogoutModal, setShowLogoutModal] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const dropdownRef = useRef();
    const [open, setOpen] = useState(false);
    const [showResetModal, setShowResetModal] = useState(false);
    const isPosPage = location.pathname === "/pos";
    const sessionToken = sessionStorage.getItem("sessionToken");
    const role = sessionStorage.getItem("role");
    const [formData, setFormData] = useState(
        {
            name: "",
            email: "",
            phoneNumber: "",
            employeeImageObject: {},
        }
    );

    const [currentTime, setCurrentTime] = useState(new Date());
    
    const confirmLogout = () => {

        sessionStorage.clear();
        toast.success('Logout successful!');
        navigate('/login');
    };


    useEffect(() => {
        function handleClickOutside(event) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setOpen(false);
            }
        }

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    useEffect(() => {
        const fetchUser = async () => {
            try {
                const token = sessionStorage.getItem("Token");
                const userId = sessionStorage.getItem("userId");
                const response = await getData(`users/user/${userId}`, token);
                const user = response?.data;
                setFormData({
                    name: user?.name || "",
                    email: user?.email || "",
                    phoneNumber: user?.phoneNumber || "",
                    employeeImageObject: user?.employeeImageObject || {},
                });
                if (user.employeeImageObject?.uri) {
                    setPreviewUrl(`${process.env.REACT_APP_API_URL}${user.employeeImageObject.uri}`);
                } else {
                    setPreviewUrl("/mdi--user.svg");
                }
            } catch (err) {
                console.error("Failed to fetch user details:", err);
            }
        };

        fetchUser();
    }, []);

    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentTime(new Date());
        }, 1000);
        return () => clearInterval(timer);
    }, []);

    return (
        <>
            <div className='header-container'>
                <div className="header-left">
                    <h2 className="page-title">
                    {currentTime.toLocaleDateString()}, {currentTime.toLocaleTimeString()}
                    </h2>
                </div>
                <div className="header-right" ref={dropdownRef}>

                    {/* Example Button */}
                    {/* <button
                        className="header-btn"
                        onClick={() => navigate(isPosPage ? "/dashboard" : "/pos")}
                        style={{ display: "flex", alignItems: "center", gap: "6px" }}
                    >
                        <Icon
                            icon={isPosPage ? "mdi:home" : "mdi:pos-terminal"} // Home icon on POS, POS icon otherwise
                            style={{ fontSize: "18px" }}
                        />
                        {isPosPage ? "Home" : "POS"}
                    </button> */}
                    
                    <div style={{ display: "flex", gap: "10px" }}>
                        {/* Home Button */}
                        <button
                            className={`header-btn ${!isPosPage ? "" : "active-btn"}`}
                            onClick={() => navigate("/dashboard")}
                            style={{ display: "flex", alignItems: "center", gap: "6px" }}
                        >
                            <Icon icon="mdi:home" style={{ fontSize: "18px" }} />
                            Home
                        </button>

                        {/* POS Button */}
                        <button
                            className={`header-btn ${isPosPage ? "" : "active-btn"}`}
                            onClick={() => navigate("/pos")}
                            style={{ display: "flex", alignItems: "center", gap: "6px" }}
                        >
                            <Icon icon="mdi:cash-register" style={{ fontSize: "18px" }} />
                            {/* <Icon icon="mdi:pos-terminal"  /> */}
                            POS
                        </button>
                    </div>
                    {/* Profile Section */}
                    <div className="profile-section" onClick={() => setOpen(prev => !prev)}>
                        <img
                            src={
                                PreviewUrl
                            }
                            alt="Profile"
                            className="profile-icon"
                        />
                        <span className="admin-label">
                            {formData.name} <span className="arrow">▼</span>
                        </span>
                    </div>

                    {/* Dropdown */}
                    {open && (
                        <div className="dropdown-menu">
                            <div className="user-info">
                                <div className="dropdown-item" onClick={() => navigate('settings/profile')}>
                                    <strong>Profile</strong>
                                </div>
                                <div className="dropdown-item" onClick={() => navigate('/settings')}>
                                    <strong>Settings</strong>
                                </div>
                                <div className="dropdown-item" onClick={() => navigate('/settings/profile')}>
                                    <strong>Change Password</strong>
                                </div>
                                <div className="dropdown-item" onClick={() => setShowLogoutModal(true)}>
                                    Logout
                                </div>
                            </div>

                        </div>
                    )}
                </div>
            </div>


            {/* Logout Modal */}
            {showLogoutModal && (
                <div className="modal-overlay">
                    <div className="modal-box">
                        <button className="modal-close" onClick={() => setShowLogoutModal(false)}>
                            &times;
                        </button>
                        <h3>Confirm Logout!</h3>
                        <p>Are you sure you want to log out?</p>
                        <div className="modal-buttons">
                            <button className="modal-btn confirm" onClick={confirmLogout}>Yes</button>
                            <button className="modal-btn cancel" onClick={() => setShowLogoutModal(false)}>Cancel</button>
                        </div>
                    </div>
                </div>
            )}

            {/* Reset Password */}
            {showResetModal && (
                <ResetPasswordPage onClose={() => setShowResetModal(false)} />
            )}
        </>
    );

};

export default ProfileDropdown;
